<script setup>
import {computed,defineEmits, defineProps} from "vue";
import {game} from "@/utils/config";

// const data = ref({});
const type = computed(()=> game.mos)
const props = defineProps({
  productLst: {
    type: Array,
    default() {
      return []
    }
  },
  account: {
    type: Object,
    default() {
      return {}
    }
  }
})

const emit = defineEmits(['login', 'checked'])
</script>

<template>
  <div class="product-lst">
    <div class="product-header">
      <el-image :src="type.headerImg"/>
    </div>
    <div class="product-lst-items">
      <div class="product-lst-info" v-for="(i,inx) in props.productLst" :key="inx"
           :style="{backgroundImage: `url('${type.productImg}')`}">
        <div class="product-price">
          <div class="face-value">
            <sup class="unit">￥</sup>{{ parseFloat(i.face_value) }}
          </div>
        </div>
        <div style="flex-basis: calc(100% - 90px);
        box-sizing: border-box;
        padding: 10px 15px;">
          <div> <b>{{ type.name }}</b></div>
          <div class="product-lst-values">
            <div class="product-values">
              <p class="jingle">{{ type.coupon_type }}</p>
              <div class="pay-miles">
                <span class="miles">{{ i.mileTypes.scal.total }}</span><span class="miles-unit">里程</span>
              </div>
            </div>
            <div class="change-data">
              <div class="pay-btn">
                <el-button type="danger" round v-if="Object.keys(props.account).length < 1"
                           @click="emit('login',i)" class="pay-success">
                  立即兑换
                </el-button>
                <el-button type="danger" round
                           v-else-if="Object.keys(props.account).length && parseInt(props.account.balance_miles) >= parseInt(i.mileTypes.scal.total)"
                           @click="emit('checked',i)" class="pay-success">
                  立即兑换
                </el-button>
                <el-button type="info" round v-else class="pay-fail">里程不足</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="less">
.product-lst {
  margin-left: 10px;
  margin-right: 10px;
  margin-bottom: 20px;
  background-color: #ffffff;
  box-shadow: var(--el-box-shadow);
  padding: 10px;
  border-radius: 12px;
  position: relative;

  .product-lst-items {
    margin-top: 25px;

    .product-lst-info {
      box-sizing: border-box;
      padding: 5px;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      display: flex;
      //height: 100px;
      margin-bottom: 10px;
      position: relative;

      .product-price {
        text-align: center;
        flex-basis: 85px;
        width: 85px;
        color: var(--view-product-lst-border-color);
        position: relative;

        .face-value {
          font-size: 1.65rem;
          font-weight: 600;
          position: absolute;
          left: 0;
          right: 0;
          top: 50%;
          height: 40px;
          margin-top: -20px;

          .unit {
            font-size: .85rem;
            margin-top: 10px;
            display: inline-block;
          }
        }

        .tips {
          position: absolute;
          font-size: .65rem;
          left: 0;
          right: 0;
          text-align: center;
          bottom: 5px;
        }
      }

      .product-lst-values {
        line-height: 1.75;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .product-values {
          color: #000;
          flex-basis: 85%;
          width: 85%;

          .jingle{
            color: var(--el-color-info);
            font-size: .75rem;
          }
          .pay-miles {
            font-size: .65rem;
            white-space: nowrap;

            .miles {
              font-size: 1.25rem;
              color: var(--view-exchange-color);
            }
          }
        }

        .change-data {
          text-align: center;


        }

        .pay-btn{
          .el-button{
            border: 0;
            position: relative;

            &.pay-success{
              background: var(--view-product-value-background-color);
            }
            &.pay-fail{
              background: var(--view-product-value-background-fail-color);
            }
          }
        }
      }
    }
  }
}
.product-header {
  height: 45px;
  text-align: center;
  line-height: 45px;
  font-size: 1.33rem;
  color: #ffffff;
  font-weight: 600;
}
</style>
